export const companiesList = [
  { label: "Company 1", value: "1" },
  { label: "Company 2", value: "2" },
  { label: "Company 3", value: "3" },
];
export const accountsList = [
  { label: "Account 1", value: "1", company_id: "3" },
  { label: "Account 2", value: "2", company_id: "3" },
  { label: "Account 3", value: "3", company_id: "2" },
];

export const publishersList = [
  { label: "Publisher 1", value: "1", account_id: "1" },
  { label: "Publisher 2", value: "2", account_id: "1" },
  { label: "Publisher 3", value: "3", account_id: "2" },
];

export const themeList = [
  { label: "Dark", value: "1" },
  { label: "Light", value: "2" },
  { label: "Default", value: "3" },
];

export const CrmList = [
  { label: "Firebase", value: "1", image: "firebase.png" },
];

export const AppList = [
  { label: "IOS", value: "ios" },
  { label: "Android", value: "android" },
  { label: "Website", value: "website" },
  { label: "SSP", value: "ssp" },
];

export const AuctionTypes = [
  { label: "First Price", value: "1" },
  { label: "Second Price", value: "2" },
  { label: "Fixed Price", value: "3" },
];

export const SupplyDealContentTypes = [
  { label: "General", value: "others" },
  { label: "Cannabis", value: "marijuana" },
  { label: "Adult Content", value: "adult" },
  { label: "Alcohol", value: "alcohol" },
  { label: "Fire Arms & Weapons", value: "firearms" },
  { label: "Political", value: "political" },
];

export const EmailConfigurationList = [
  {
    label: "Gmail",
    value: "gmail",
    logo: "https://upload.wikimedia.org/wikipedia/commons/7/7e/Gmail_icon_%282020%29.svg",
  },
  //{ label: "Yahoo", value: "yahoo", logo: "https://s.yimg.com/rz/p/yahoo_frontpage_en-US_s_f_p_bestfit_frontpage_2x.png" },
];

export const EmailReportDayOptions = {
  0: "Never",
  1: "Sunday",
  2: "Monday",
  3: "Tuesday",
  4: "Wednesday",
  5: "Thursday",
  6: "Friday",
  7: "Saturday",
  8: "Everyday",
};
export const EmailReportTypeOptions = {
  0: "Basic",
  1: "Location(City/State)",
  2: "Location(State)",
  3: "Location(Zip)",
  4: "Performance Report",
  5: "Summary Report",
};

export const DspBidderTypes = [
  { label: "Audio Supply", value: "audio" },
  { label: "Display Supply", value: "banner" },
  { label: "Native Display", value: "native_banner" },
  { label: "Native Video", value: "native_video" },
  { label: "Video Supply", value: "video" },
];
export const BidderEmailReportTypeOptions = {
  0: "Summary",
  1: "Domain / Bundle Id",
};

export const RequestCompression = [
  { label: "Plain Text", value: "0" },
  { label: "gzip", value: "1" },
];
export const SeatType = [
  {
    label: "Public",
    value: "0",
    tooltip:
      "Demand will have access to inventory across platform inventory including private.",
  },
  {
    label: "Protected",
    value: "1",
    tooltip:
      "Demand will have access to inventory coming other than same account.",
  },
  {
    label: "Private",
    value: "2",
    tooltip: "Demand will have access to inventory coming within account.",
  },
];
export const IntegrationType = [
  {
    label: "Open RTB",
    value: "1",
  },
  {
    label: "Pre-bid",
    value: "2",
  },
  {
    label: "Tag Based",
    value: "3",
  },
];
export const AuctionType = [
  {
    label: "First Price",
    value: "1",
  },
  {
    label: "Second Price",
    value: "2",
  },
];
export const QPSOptimizationList = [
  { label: "None", value: "0" },
  { label: "Realtime", value: "1" },
  { label: "Historical (Hybrid)", value: "2" },
];
export const DspQpsOptParmeters = [
  { label: "Bundle", value: "bundle" },
  { label: "ImpType", value: "imptype" },
  { label: "Size", value: "size" },
  { label: "Country", value: "country" },
  { label: "OS", value: "os" },
  { label: "Publisher", value: "publisher" },
  { label: "Placement", value: "placement" },
];
export const RTBVersionList = [
  { label: "2.1", value: "2.1" },
  { label: "2.2", value: "2.2" },
  { label: "2.3", value: "2.3" },
  { label: "2.4", value: "2.4" },
  { label: "2.5", value: "2.5" },
];

export const GroupByList = [
  { label: "Date", value: "date" },
  { label: "DayHour", value: "hour" },
  { label: "Account", value: "account" },
  { label: "Advertiser", value: "advertiser" },
  { label: "Campaign", value: "package" },
  { label: "Ad Group", value: "campaign" },
  { label: "Creative", value: "banner" },
  // { label: "Attribution", value: "attribution" },
  { label: "Publisher", value: "publisher" },
  { label: "Placement ID ", value: "placementid" },
  //{ label: "Sales Rep", value: "sales_rep" },
  { label: "Inventory Type ", value: "imptype" },
];
export const PubReportGroupByList = [
  { label: "Date", value: "date" },
  { label: "DayHour", value: "hour" },
  { label: "Account", value: "account" },
  // { label: "Attribution", value: "attribution" },
  { label: "Publisher", value: "publisher" },

  //{ label: "Sales Rep", value: "sales_rep" },
  { label: "Inventory Type ", value: "imptype" },
  { label: "Placement ID ", value: "placementid" },
  //{ label: "DSP ID", value: "bidder" },
  //{ label: "Sales Rep", value: "sales_rep" },
];

export const BidReportGroupByList = [
  { label: "Date", value: "date" },
  { label: "DayHour", value: "hour" },
  { label: "Account", value: "account" },
  { label: "Bidder", value: "bidder" },
  { label: "Seat", value: "seat" },
  { label: "Publisher", value: "publisher" },
  { label: "Placement ID ", value: "placementid" },
  { label: "QPS Algo Id", value: "dspqpsalgo" },
  { label: "Inventory Type ", value: "imptype" },

  // { label: "Sales Rep", value: "sales_rep" },
];

export const BidderWrapUpReportGroupByList = [
  { label: "Date", value: "date" },
  { label: "Tag ID", value: "tagid" },
];

export const sortBysOptions = [
  { label: "Wins", value: "winbids" },
  { label: "Losses", value: "losebids" },
  { label: "Ignores", value: "discardbids" },
  { label: "Gross", value: "revenue" },
  { label: "Net", value: "netrevenue" },
  { label: "Impressions", value: "impressions" },
  { label: "Viewable", value: "viewable" },
  { label: "Life", value: "life" },
  { label: "Render Time", value: "rendertime" },
  { label: "Cache Time", value: "cachetime" },
  { label: "Click Time", value: "clicktime" },
  { label: "Clicks", value: "clicks" },
  { label: "Conversions", value: "conversions" },
  { label: "Completes", value: "completes" },

  { label: "Duplicates", value: "duplicates" },
  { label: "Expired", value: "expired" },
  { label: "IP Frauds", value: "ipfrauds" },
  { label: "UA Frauds", value: "uafrauds" },
  { label: "REF Frauds", value: "reffrauds" },
  { label: "Pub Frauds", value: "bundlefrauds" },
];

export const analyticORSupplyDashboardTiles = {
  system_overview: [
    { name: "Bids", key: "bids" },
    { name: "Wins", key: "winbids" },
    { name: "Losses", key: "losebids" },
    { name: "Ignores", key: "discardbids" },
    { name: "eWins", key: "ewins" },
    { name: "eLoss", key: "eloss" },
    { name: "Load", key: "load" },
    { name: "Renders", key: "adrenders" },
    { name: "Ad Errors", key: "aderrors" },
  ],
  performance_metrics: [
    { name: "Impressions", key: "impressions" },
    { name: "Viewable", key: "viewable" },
    { name: "Life", key: "life" },
    { name: "Render Time", key: "rendertime" },
    { name: "Cache Time", key: "cachetime" },
    { name: "Click Time", key: "clicktime" },
    { name: "Clicks", key: "clicks" },
    { name: "CTR", key: "ctr" },
    { name: "eCPM", key: "ecpm", suffix: "$" },
    { name: "Conversions", key: "conversions" },
    { name: "Completes", key: "completes" },
  ],
  adtraffic_ops: [
    { name: "Win Price", key: "avgwinprice", suffix: "$" },
    { name: "Pub Bid", key: "pubbidprice", suffix: "$" },
    { name: "Bid Price", key: "avgfinalprice", suffix: "$" },
    { name: "Req.Floor", key: "avgfloor", suffix: "$" },
    { name: "Loss Price", key: "avgloseprice", suffix: "$" },
    { name: "Ignore Price", key: "avgdiscardprice", suffix: "$" },
    { name: "Gross", key: "revenue", suffix: "$" },
    { name: "Net", key: "netrevenue", suffix: "$" },
  ],
  adquality_metrics: [
    { name: "Duplicates", key: "duplicates" },
    { name: "Expired", key: "expired" },
    { name: "IP Frauds", key: "ipfrauds" },
    { name: "UA Frauds", key: "uafrauds" },
    { name: "REF Frauds", key: "reffrauds" },
    { name: "Pub Frauds", key: "bundlefrauds" },
  ],
};

export const analyticeOrSupplyDashboardtilesSection = {
  system_overview: {
    name: "System Overview",
    label_color: "#26a65b",
    font_color: "#fff",
  },
  performance_metrics: {
    name: "Performance Metrics",
    label_color: "#ffd800",
    font_color: "#fff",
  },
  adtraffic_ops: {
    name: "Ad Trafficking & Ops",
    label_color: "#0094ff",
    font_color: "#fff",
  },
  adquality_metrics: {
    name: "Ad Quality Metrics",
    label_color: "#7f0000",
    font_color: "#fff",
  },
};

export const summary_options_ext = {
  // System Overview - Grouping
  bids: {
    label: "Bids",
    ui_group_id: "system_overview",
    color: "#8884d8",
  },
  winbids: {
    label: "Wins",
    sort: true,
    ui_group_id: "system_overview",
    color: "#e96d8d",
  },
  losebids: {
    label: "Losses",
    sort: true,
    ui_group_id: "system_overview",
    color: "#82ca9d",
  },
  discardbids: {
    label: "Ignores",
    sort: true,
    ui_group_id: "system_overview",
    color: "#2b908f",
  },
  ewins: {
    label: "eWins",
    visible: false,
    ui_group_id: "system_overview",
    color: "#7cb5ec",
  },
  eloss: {
    label: "eLoss",
    visible: false,
    ui_group_id: "system_overview",
    color: "#42f5e0",
  },
  // Ad Trafficking & Ops - Grouping
  avgwinprice: {
    label: "Win Price",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#fcba03",
  },
  pubbidprice: {
    label: "Pub Bid($)",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#b03f78",
  },
  avgfinalprice: {
    label: "Bid Price",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#03fcb1",
  },
  avgfloor: {
    label: "Req. Floor",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#03c2fc",
  },
  avgloseprice: {
    label: "Loss Price",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#a103fc",
  },
  avgdiscardprice: {
    label: "Ignore Price",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#fc0390",
  },
  revenue: {
    label: "Gross",
    sort: true,
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#434348",
  },
  netrevenue: {
    label: "Net",
    sort: true,
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#fc035e",
  },
  // Performance Metrics - Grouping
  load: {
    label: "Load",
    visible: false,
    ui_group_id: "system_overview",
    color: "#ad5ba0",
  },
  adrenders: {
    label: "Renders",
    visible: false,
    ui_group_id: "system_overview",
    color: "#dd5ea0",
  },
  aderrors: {
    label: "Ad Errors",
    visible: false,
    ui_group_id: "system_overview",
    color: "#2e5ba0",
  },
  impressions: {
    label: "Impressions",
    sort: true,
    visible: true,
    default_sort: true,
    default_sort_max_tile: true,
    ui_group_id: "performance_metrics",
    color: "#f7a35c",
  },
  viewable: {
    label: "Viewable",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#8085e9",
  },
  life: {
    label: "Life",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#f15c80",
  },
  rendertime: {
    label: "Render Time",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#e4d354",
  },
  cachetime: {
    label: "Cache Time",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#735ba0",
  },
  clicktime: {
    label: "Click Time",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#f45b5b",
  },
  clicks: {
    label: "Clicks",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#91e8e1",
  },
  ctr: {
    label: "CTR",
    suffix: "%",
    visible: true,
    ui_group_id: "performance_metrics",
    color: "#2eb3a0",
  },
  ecpm: {
    label: "eCPM",
    prefix: "$",
    visible: true,
    ui_group_id: "performance_metrics",
    color: "#f5ce42",
  },
  conversions: {
    label: "Conversions",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#434348",
  },
  completes: {
    label: "Completes",
    sort: true,
    visible: false,
    ui_group_id: "performance_metrics",
    color: "#90ed7d",
  },
  // Ad Quality Metrics - Grouping
  duplicates: {
    label: "Duplicates",
    sort: true,
    visible: false,
    ui_group_id: "adquality_metrics",
    color: "#f45b5b",
  },
  expired: {
    label: "Expired",
    sort: true,
    visible: false,
    ui_group_id: "adquality_metrics",
    color: "#e4d354",
  },
  ipfrauds: {
    label: "IP Frauds",
    sort: true,
    visible: false,
    ui_group_id: "adquality_metrics",
    color: "#c11b00",
  },
  uafrauds: {
    label: "UA Frauds",
    sort: true,
    visible: false,
    ui_group_id: "adquality_metrics",
    color: "#eb4034",
  },
  reffrauds: {
    label: "REF Frauds",
    sort: true,
    visible: false,
    ui_group_id: "adquality_metrics",
    color: "#df5ba0",
  },
  bundlefrauds: {
    label: "Pub Frauds",
    sort: true,
    visible: false,
    ui_group_id: "adquality_metrics",
    color: "#b65ba0",
  },
};

export const supplyDashboardSortBysOptions = [
  { label: "Auctions", value: "auctions" },
  { label: "Requests", value: "requests" },
];

export const supplydashboard_summary_options_ext = {
  // Performance Metrics - Grouping
  requests: {
    label: "Requests",
    sort: true,
    ui_group_id: "performance_metrics",
    color: "#8884d8",
  },
  qps: {
    label: "QPS",
    sort: false,
    ui_group_id: "performance_metrics",
    color: "#e96d8d",
  },
  // System Overview - Grouping
  auctions: {
    label: "Auctions",
    sort: true,
    default_sort: true,
    default_sort_max_tile: true,
    ui_group_id: "system_overview",
    color: "#82ca9d",
  },
  // Ad Trafficking & Ops - Grouping
  avgbasefloor: {
    label: "Base Floor",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#2b908f",
  },
  avgpubfloor: {
    label: "Pub Floor",
    prefix: "$",
    ui_group_id: "adtraffic_ops",
    color: "#7cb5ec",
  },
  avglatency: {
    label: "Latency (ms)",
    prefix: "",
    ui_group_id: "adtraffic_ops",
    color: "#42f5e0",
  },

  avgtmax: {
    label: "tMax (ms)",
    prefix: "",
    ui_group_id: "adtraffic_ops",
    color: "#fcba03",
  },
};

export const countriesList = {
  ABW: "Aruba",
  AFG: "Afghanistan",
  AGO: "Angola",
  AIA: "Anguilla",
  ALA: "Aland Islands",
  ALB: "Albania",
  AND: "Andorra",
  ARE: "United Arab Emirates",
  ARG: "Argentina",
  ARM: "Armenia",
  ASM: "American Samoa",
  ATA: "Antarctica",
  ATF: "French Southern Territories",
  ATG: "Antigua and Barbuda",
  AUS: "Australia",
  AUT: "Austria",
  AZE: "Azerbaijan",
  BDI: "Burundi",
  BEL: "Belgium",
  BEN: "Benin",
  BES: "Bonaire, Sint Eustatius and Saba",
  BFA: "Burkina Faso",
  BGD: "Bangladesh",
  BGR: "Bulgaria",
  BHR: "Bahrain",
  BHS: "Bahamas",
  BIH: "Bosnia and Herzegovina",
  BLM: "Saint Barthélemy",
  BLR: "Belarus",
  BLZ: "Belize",
  BMU: "Bermuda",
  BOL: "Bolivia, Plurinational State of",
  BRA: "Brazil",
  BRB: "Barbados",
  BRN: "Brunei Darussalam",
  BTN: "Bhutan",
  BVT: "Bouvet Island",
  BWA: "Botswana",
  CAF: "Central African Republic",
  CAN: "Canada",
  CCK: "Cocos (Keeling) Islands",
  CHE: "Switzerland",
  CHL: "Chile",
  CHN: "China",
  CIV: "Côte d'Ivoire",
  CMR: "Cameroon",
  COD: "Congo, the Democratic Republic of the",
  COG: "Congo",
  COK: "Cook Islands",
  COL: "Colombia",
  COM: "Comoros",
  CPV: "Cabo Verde",
  CRI: "Costa Rica",
  CUB: "Cuba",
  CUW: "Curaçao",
  CXR: "Christmas Island",
  CYM: "Cayman Islands",
  CYP: "Cyprus",
  CZE: "Czech Republic",
  DEU: "Germany",
  DJI: "Djibouti",
  DMA: "Dominica",
  DNK: "Denmark",
  DOM: "Dominican Republic",
  DZA: "Algeria",
  ECU: "Ecuador",
  EGY: "Egypt",
  ERI: "Eritrea",
  ESH: "Western Sahara",
  ESP: "Spain",
  EST: "Estonia",
  ETH: "Ethiopia",
  FIN: "Finland",
  FJI: "Fiji",
  FLK: "Falkland Islands (Malvinas)",
  FRA: "France",
  FRO: "Faroe Islands",
  FSM: "Micronesia, Federated States of",
  GAB: "Gabon",
  GBR: "United Kingdom",
  GEO: "Georgia",
  GGY: "Guernsey",
  GHA: "Ghana",
  GIB: "Gibraltar",
  GIN: "Guinea",
  GLP: "Guadeloupe",
  GMB: "Gambia",
  GNB: "Guinea-Bissau",
  GNQ: "Equatorial Guinea",
  GRC: "Greece",
  GRD: "Grenada",
  GRL: "Greenland",
  GTM: "Guatemala",
  GUF: "French Guiana",
  GUM: "Guam",
  GUY: "Guyana",
  HKG: "Hong Kong",
  HMD: "Heard Island and McDonald Islands",
  HND: "Honduras",
  HRV: "Croatia",
  HTI: "Haiti",
  HUN: "Hungary",
  IDN: "Indonesia",
  IMN: "Isle of Man",
  IND: "India",
  IOT: "British Indian Ocean Territory",
  IRL: "Ireland",
  IRN: "Iran, Islamic Republic of",
  IRQ: "Iraq",
  ISL: "Iceland",
  ISR: "Israel",
  ITA: "Italy",
  JAM: "Jamaica",
  JEY: "Jersey",
  JOR: "Jordan",
  JPN: "Japan",
  KAZ: "Kazakhstan",
  KEN: "Kenya",
  KGZ: "Kyrgyzstan",
  KHM: "Cambodia",
  KIR: "Kiribati",
  KNA: "Saint Kitts and Nevis",
  KOR: "Korea, Republic of",
  KWT: "Kuwait",
  LAO: "Lao People's Democratic Republic",
  LBN: "Lebanon",
  LBR: "Liberia",
  LBY: "Libya",
  LCA: "Saint Lucia",
  LIE: "Liechtenstein",
  LKA: "Sri Lanka",
  LSO: "Lesotho",
  LTU: "Lithuania",
  LUX: "Luxembourg",
  LVA: "Latvia",
  MAC: "Macao",
  MAF: "Saint Martin (French part)",
  MAR: "Morocco",
  MCO: "Monaco",
  MDA: "Moldova, Republic of",
  MDG: "Madagascar",
  MDV: "Maldives",
  MEX: "Mexico",
  MHL: "Marshall Islands",
  MKD: "Macedonia, the former Yugoslav Republic of",
  MLI: "Mali",
  MLT: "Malta",
  MMR: "Myanmar",
  MNE: "Montenegro",
  MNG: "Mongolia",
  MNP: "Northern Mariana Islands",
  MOZ: "Mozambique",
  MRT: "Mauritania",
  MSR: "Montserrat",
  MTQ: "Martinique",
  MUS: "Mauritius",
  MWI: "Malawi",
  MYS: "Malaysia",
  MYT: "Mayotte",
  NAM: "Namibia",
  NCL: "New Caledonia",
  NER: "Niger",
  NFK: "Norfolk Island",
  NGA: "Nigeria",
  NIC: "Nicaragua",
  NIU: "Niue",
  NLD: "Netherlands",
  NOR: "Norway",
  NPL: "Nepal",
  NRU: "Nauru",
  NZL: "New Zealand",
  OMN: "Oman",
  PAK: "Pakistan",
  PAN: "Panama",
  PCN: "Pitcairn",
  PER: "Peru",
  PHL: "Philippines",
  PLW: "Palau",
  PNG: "Papua New Guinea",
  POL: "Poland",
  PRI: "Puerto Rico",
  PRK: "Korea, Democratic People's Republic of",
  PRT: "Portugal",
  PRY: "Paraguay",
  PSE: "Palestine, State of",
  PYF: "French Polynesia",
  QAT: "Qatar",
  REU: "Réunion",
  ROU: "Romania",
  RUS: "Russian Federation",
  RWA: "Rwanda",
  SAU: "Saudi Arabia",
  SDN: "Sudan",
  SEN: "Senegal",
  SGP: "Singapore",
  SGS: "South Georgia and the South Sandwich Islands",
  SHN: "Saint Helena, Ascension and Tristan da Cunha",
  SJM: "Svalbard and Jan Mayen",
  SLB: "Solomon Islands",
  SLE: "Sierra Leone",
  SLV: "El Salvador",
  SMR: "San Marino",
  SOM: "Somalia",
  SPM: "Saint Pierre and Miquelon",
  SRB: "Serbia",
  SSD: "South Sudan",
  STP: "Sao Tome and Principe",
  SUR: "Suriname",
  SVK: "Slovakia",
  SVN: "Slovenia",
  SWE: "Sweden",
  SWZ: "Swaziland",
  SXM: "Sint Maarten (Dutch part)",
  SYC: "Seychelles",
  SYR: "Syrian Arab Republic",
  TCA: "Turks and Caicos Islands",
  TCD: "Chad",
  TGO: "Togo",
  THA: "Thailand",
  TJK: "Tajikistan",
  TKL: "Tokelau",
  TKM: "Turkmenistan",
  TLS: "Timor-Leste",
  TON: "Tonga",
  TTO: "Trinidad and Tobago",
  TUN: "Tunisia",
  TUR: "Turkey",
  TUV: "Tuvalu",
  TWN: "Taiwan, Province of China",
  TZA: "Tanzania, United Republic of",
  UGA: "Uganda",
  UKR: "Ukraine",
  UMI: "United States Minor Outlying Islands",
  URY: "Uruguay",
  USA: "United States",
  UZB: "Uzbekistan",
  VAT: "Holy See (Vatican City State)",
  VCT: "Saint Vincent and the Grenadines",
  VEN: "Venezuela, Bolivarian Republic of",
  VGB: "Virgin Islands, British",
  VIR: "Virgin Islands, U.S.",
  VNM: "Viet Nam",
  VUT: "Vanuatu",
  WLF: "Wallis and Futuna",
  WSM: "Samoa",
  YEM: "Yemen",
  ZAF: "South Africa",
  ZMB: "Zambia",
  ZWE: "Zimbabwe",
};

export const adSizeListJS = {
  "320x50": "320x50",
  "300x50": "300x50",
  "300x250": "300x250",
  "320x250": "320x250",
  "320x480": "320x480",
  "480x320": "480x320",
  "728x90": "728x90",
  "90x728": "90x728",
  "1024x768": "1024x768",
  "768x1024": "768x1024",
  "320x568": "320x568",
  "568x320": "568x320",
  "160x600": "160x600",
  "600x160": "600x160",
  "300x600": "300x600",
  "600x300": "600x300",
  "250x250": "250x250",
  "200x200": "200x200",
  "320x100": "320x100",
  "300x100": "300x100",
};

export const bidPriceImpTypes = {
  audio: "Audio Supply",
  banner: "Display Supply",
  native_banner: "Native Display",
  native_video: "Native Video",
  video: "Video Supply",
};

export const retargetTypeList = [
  { label: "Impressions", value: "1" },
  { label: "Clicks", value: "3" },
  { label: "Completed Views", value: "4" },
  { label: "FQ (25%)", value: "7" },
  { label: "MP (25%)", value: "8" },
  { label: "TQ (25%)", value: "9" },
];
export const ProfilesList = {
  advertiser: "Advertiser",
  publisher: "Publisher",
  bidder: "Bidder",
};

export const ProfilesOptionsList = [
  { label: "Advertiser", value: "advertiser" },
  { label: "Publisher", value: "publisher" },
  { label: "Bidder", value: "bidder" },
];
export const Providers = [
  "clickagy",
  "peerlogix",
  "L2_Political",
  "kurrys",
  "kurryp",
  "mobiquity",
  "mcon",
  "global",
  "techintlabs",
  "microssp",
  "prevads",
  "mobqcustom",
  "geointel_tags",
  "pixel",
  "retarget",
  "crm",
];
export const ProvidersNameList = {
  clickagy: "Clickagy",
  peerlogix: "PeerLogix",
  L2_Political: "L2_Political",
  kurrys: "kurrys",
  kurryp: "kurryp",
  mobiquity: "Mobiquity Networks",
  mcon: "Contextual Engine",
  global: "Global Segments",
  techintlabs: "Techint Labs",
  microssp: "Micro Segments",
  prevads: "AdHere",
  mobqcustom: "Campaign Segments",
  geointel_tags: "GeoIntel",
  pixel: "Sites",
  retarget: "Retargeting",
  crm: "CRM",
};

export const DaysOfWeek = {
  1: "Sunday",
  2: "Monday",
  3: "Tuesday",
  4: "Wednesday",
  5: "Thursday",
  6: "Friday",
  7: "Saturday",
};

export const DayOfHours = {
  0: "00:00",
  1: "01:00",
  2: "02:00",
  3: "03:00",
  4: "04:00",
  5: "05:00",
  6: "06:00",
  7: "07:00",
  8: "08:00",
  9: "09:00",
  10: "10:00",
  11: "11:00",
  12: "12:00",
  13: "13:00",
  14: "14:00",
  15: "15:00",
  16: "16:00",
  17: "17:00",
  18: "18:00",
  19: "19:00",
  20: "20:00",
  21: "21:00",
  22: "22:00",
  23: "23:00",
};
export const deviceTypes = {
  clicks: {
    data: [
      {
        name: "Phone",
        value: 205,
      },
      {
        value: 21,
        name: "Personal Computer",
      },
      {
        value: 18,
        name: "Tablet",
      },
      {
        value: 1,
        name: "Connected TV",
      },
      {
        value: 0,
        name: "Mobile/Tablet",
      },
      {
        value: 0,
        name: "Set Top Box",
      },
      {
        value: 0,
        name: "Connected Device",
      },
      {
        value: 0,
        name: "ALL",
      },
    ],
    updatedAt: "1713418216838",
  },
  impressions: {
    data: [
      {
        value: 130428,
        name: "Phone",
      },
      {
        value: 14613,
        name: "Personal Computer",
      },
      {
        value: 13975,
        name: "Tablet",
      },
      {
        value: 3033,
        name: "Connected TV",
      },
      {
        value: 432,
        name: "Set Top Box",
      },
      {
        value: 7,
        name: "Connected Device",
      },
      {
        value: 1,
        name: "Mobile/Tablet",
      },
      {
        impressions: 0,
        device_type: "ALL",
      },
    ],
    updatedAt: "1713418216907",
  },
};

export const CampaignReportConfigureLabel = {
  impressions: "Impressions",
  clicks: "Clicks",
  viewables: "Viewables",
  uniques: "Uniques",
  datacost: "Data Cost",
  attribution_cost: "Attribution Cost",
  margin: "Margin",
  spend: "Spend",
  net: "Net",
  load: "Load",
  start: "Start",
  first_quartile: "First Quartile",
  mid_point: "Mid Point",
  third_quartile: "Third Quartile",
  complete: "Video Complete",
  close: "Close",
  conversions: "Conversions",
  roi: "ROI",
  available: "Available",
  qualify: "Qualify",
  os: "Os",
  device_type: "Device Type",
  target_address_groups: "Address Group",
  target_addresses: "Address",
  requests: "Requests",
  target_brands: "Brands",
  target_city: "City",
  target_congressional_districts: "Congressional Districts",
  target_dma: "DMA",
  target_house_districts: "House Districts",
  target_ipaddress_groups: "IPAddress Group",
  target_latlon_groups: "LatLon Group",
  target_postalcode: "Zip/PostalCode",
  target_senate_districts: "Senate Districts",
  target_state: "States",
  day_part: "Day Part",

  dow: "Day Of Week",
  vcr: "Vcr",
  ctr: "CTR",
  campaign_id: "Ad Group ID",
  creative_id: "Creative ID",
};

export const MasterAllowProvidersListInManageSegments = [
  { value: "microssp", label: "Micro Segments" },
  { value: "prevads", label: "AdHere" },
  { value: "mcon", label: "Contextual Engine" },
];

export const TargetingGroupTypesGlobal = [
  { value: "zipcode", label: "Zipcodes" },
  { value: "latlon", label: "Latitude-Longitude" },
  { value: "polygon", label: "Polygon" },
  { value: "address", label: "Addresses" },
  { value: "bundleid", label: "Bundle IDs OR Domain Names" },
  { value: "email", label: "Email Addresses" },
  {
    value: "email_sha2_256_lower",
    label: "EMail Addresses hashed with SHA256 in lowercase",
  },
  {
    value: "email_sha2_256_upper",
    label: "EMail Addresses hashed with SHA256 in uppercase",
  },
  { value: "ipaddress", label: "IP Address" },
];

export const globalKeepMetrics = {
  // impressions: "Impressions",
  // clicks: "Clicks",
  // conversions: "Conversions",
  // ctr: "CTR",
  vcr: "VCR",
  spend: "Spend",
  net: "Net",
  profit: "Profit",
  viewing_hours: "Viewing Hours",
  conversion_roi: "Revenue",
  complete: "Video Complete",
  viewables: "Views",
};
export const globalKeepMetricsSections = {
  performance_by_creative: "Performance By Creative",
  campaign_summary: "Ad Group Summary",
  daily_performance: "Daily Performance",
  performance_by_dayOfWeek: "Performance By Day Of Week",
  performance_by_deviceType: "Performance By Device Type",
  performance_by_inventory: "Performance By Inventory",
  performance_by_platform: "Performance By Platform",
  performance_by_dayPart: "Performance By Daypart",
  performance_by_geo: "Performance By Geo",
  performance_by_zip: "Performance By Zip/Postal Code",
  campaign_targeting: "Ad Group Targeting",
};
